import {computed, signal} from "@preact/signals-react";
import initials from "initials";
import {IProfile} from "@/app/dashboard/models/User";

export const userDetails = signal<IProfile>();

export const avatarInitials = computed(() => {
    const text = initials(`${userDetails.value?.firstName ?? ""} ${userDetails.value?.lastName ?? ""}`)?.toUpperCase() ?? "";
    if (text.length > 2) {
        return text.slice(0, 2);
    }
    return text;
})